import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { UnarchiveEstimateMutation as UnarchiveEstimateMutationResult } from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const UnarchiveEstimateMutation = graphql(`
  mutation UnarchiveEstimate($id: ID!) {
    unarchiveEstimate(id: $id) {
      id
    }
  }
`);

const useUnarchiveEstimate = (args: {
  projectId: string;
  options?: UseMutationOptions<
    UnarchiveEstimateMutationResult,
    Error,
    { id: string }
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation({
    mutationFn: (variables: { id: string }) => {
      return gqlClient.request(UnarchiveEstimateMutation, variables);
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.estimates(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUnarchiveEstimate;
